export interface SetActiveWallpaperRequest {
  wallpaper_type: 'predefined' | 'custom'
  wallpaper_id: string
}

export interface SetActiveWallpaperResponse {
  success: boolean
  data: unknown
}
